var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TableCell, TableRow, Box, Typography, Button, Checkbox, } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { DATE_ERROR_MESSAGE, DATE_FORMAT, DIALOG_TYPES, INVALID_DATE, } from 'globals/global.constants';
import moment from 'moment';
import { GoalStatus } from 'globals/enums';
import { InputFields } from 'common/InputFields';
import { openDialog } from 'store/commonReducer/common.action';
import { goalsStyle } from './Goals.style';
import { UPDATE_GOAL_CONTEXT, DELETE_GOAL_CONTEXT, } from '../wellnessPlanContext/reducer';
import { AttachIconWithCount } from 'common/AttachFiles/AttachIconWithCount';
import { openResourcesDialog } from '../SeniorWellnessPlan.action';
import { WellnessPlanContext } from '../wellnessPlanContext/WellnessPlan.context';
import { GET_GOALS_NOTES_LOADING, getGoalsNotesData, statusChangeGoalActionMap, updateGoals } from 'store/goals/goals.action';
var GoalsTableRow = React.memo(function (_a) {
    var _b;
    var rowData = _a.rowData, goalsActionMap = _a.goalsActionMap, isDeleteDisable = _a.isDeleteDisable, goalProgressSteps = _a.goalProgressSteps, customerID = _a.customerID, selectedSeniorCareGiver = _a.selectedSeniorCareGiver, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var classes = goalsStyle().classes;
    var dispatch = useAppDispatch();
    var _e = React.useState(''), errorTextStart = _e[0], setErrorTextStart = _e[1];
    var _f = React.useState(''), errorTextTarget = _f[0], setErrorTextTarget = _f[1];
    var _g = React.useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = React.useState(rowData.status !== 'not_started'), localChecked = _h[0], setLocalChecked = _h[1];
    var dispatchContext = React.useContext(WellnessPlanContext).dispatchContext;
    var isLatestVersion = useAppSelector(function (state) { return state.wellnessPlan; }).isLatestVersion;
    var tableData = useAppSelector(function (state) { return state.goals.goalsRowsData; });
    var seniorCreatedDate = useAppSelector(function (state) { return state.common.seniorDetail.minimalInfo.created_date; });
    var currentRow = tableData === null || tableData === void 0 ? void 0 : tableData.find(function (data) { return data.id === rowData.id; });
    /**
     * @function handleChangeProgress
     * @description to handle goal progress percentage
     * @param event
     * @param newValue
     * @param activeThumb
     */
    var handleChangeProgress = function (event, newValue, activeThumb) {
        /** set progress value only if the new value is greater than the previous value */
        if ((currentRow === null || currentRow === void 0 ? void 0 : currentRow.id) && newValue >= (currentRow === null || currentRow === void 0 ? void 0 : currentRow.progress)) {
            updateGoalContext(newValue, 'progress');
        }
        /** Not allow user to set progress value 100 if the goal is not saved yet */
        if (!(currentRow === null || currentRow === void 0 ? void 0 : currentRow.id) && newValue < 100) {
            updateGoalContext(newValue, 'progress');
        }
    };
    /**
     * @function handleChange
     * @description to handle change event on input fields
     * @param e
     */
    var handleChange = function (e) {
        if (disabled)
            return;
        dispatch(updateGoals(e.target.value, e.target.name, rowData, dispatchContext, isCustomRow));
    };
    var handleDateChange = function (date, name) {
        if (disabled)
            return;
        dispatchContext({
            type: UPDATE_GOAL_CONTEXT,
            payload: {
                id: rowData.newGoalId || rowData.id,
                value: date || '',
                name: name,
            },
        });
    };
    React.useEffect(function () {
        // Keep local state in sync if rowData changes externally
        setLocalChecked(rowData.status !== 'not_started');
    }, [rowData.status]);
    var deleteGoalhandler = function () {
        if (disabled)
            return;
        var openDialogProp = {
            boldMessage: "Are you sure you want to Remove this Goal from the table?",
            successButtonText: 'Confirm',
            type: DIALOG_TYPES.ADMIN_ACTION_DIALOG,
            isFailButton: true,
            onSuccessButton: function () {
                dispatchContext({
                    type: DELETE_GOAL_CONTEXT,
                    payload: __assign({}, rowData),
                });
                if (rowData.goal && rowData.action) {
                    dispatch(statusChangeGoalActionMap(rowData.goal, rowData.action, rowData.newGoalId || rowData.id));
                }
            },
        };
        dispatch(openDialog(__assign({}, openDialogProp)));
    };
    var resourceshandler = function (unsavedData, rowDisable) {
        if (disabled)
            return;
        dispatch(openResourcesDialog(unsavedData, dispatchContext, selectedSeniorCareGiver, rowDisable));
    };
    var isGoalInUse = React.useCallback(function (goalName) {
        return tableData === null || tableData === void 0 ? void 0 : tableData.some(function (item) {
            return (item.goalType === rowData.goalType &&
                item.goal === goalName &&
                item.id !== (rowData.newGoalId || rowData.id) &&
                item.status !== GoalStatus.Completed &&
                item.status !== GoalStatus.Cancelled);
        });
    }, [tableData, rowData.goalType, rowData.id, rowData.newGoalId]);
    var isActionInUse = React.useCallback(function (actionName) {
        return tableData === null || tableData === void 0 ? void 0 : tableData.some(function (item) {
            return (item.goalType === rowData.goalType &&
                item.goal === rowData.goal &&
                item.action === actionName &&
                item.status !== GoalStatus.Completed &&
                item.status !== GoalStatus.Cancelled);
        });
    }, [tableData, rowData.goalType, rowData.goal]);
    var goalsList = React.useMemo(function () {
        var goals = Object.values(goalsActionMap)
            .filter(function (item) {
            if (!item.occupied ||
                (item.occupied &&
                    item.rowIds.some(function (item) { return item === (rowData.newGoalId || rowData.id); }))) {
                return item;
            }
        })
            .map(function (item) {
            return {
                value: item.goalName,
                label: item.goalName,
            };
        });
        return goals;
    }, [goalsActionMap, rowData.id, rowData.newGoalId]);
    var actionList = React.useMemo(function () {
        var _a, _b, _c;
        var subActions = (_c = (_b = (_a = goalsActionMap === null || goalsActionMap === void 0 ? void 0 : goalsActionMap[rowData.goalType]) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b[rowData.goal]) === null || _c === void 0 ? void 0 : _c.subActions;
        if (!subActions || typeof subActions !== 'object') {
            return [];
        }
        return Object.values(subActions)
            .filter(function (item) {
            var rowIds = Array.isArray(item.rowId) ? item.rowId : [];
            var currentRowId = rowData.newGoalId || rowData.id;
            var isCurrentSelection = item.actionName === rowData.action;
            var matchesRowId = rowIds.includes(currentRowId);
            return (isCurrentSelection ||
                matchesRowId ||
                !isActionInUse(item.actionName));
        })
            .map(function (item) { return ({
            value: item.actionName,
            label: item.actionName,
        }); });
    }, [
        goalsActionMap,
        rowData.goalType,
        rowData.goal,
        rowData.id,
        rowData.newGoalId,
        rowData.action,
    ]);
    var goalList = React.useMemo(function () {
        var _a;
        if (!rowData.goalType ||
            !((_a = goalsActionMap[rowData.goalType]) === null || _a === void 0 ? void 0 : _a.actions)) {
            return [];
        }
        return Object.values(goalsActionMap[rowData.goalType].actions)
            .filter(function (item) {
            var _a;
            var goalName = (_a = item.goalName) !== null && _a !== void 0 ? _a : item.actionName;
            var isCurrentSelection = goalName === rowData.goal;
            return (isCurrentSelection || !isGoalInUse(goalName));
        })
            .map(function (item) {
            var _a, _b;
            return ({
                value: (_a = item.goalName) !== null && _a !== void 0 ? _a : item.actionName,
                label: (_b = item.goalName) !== null && _b !== void 0 ? _b : item.actionName,
            });
        });
    }, [
        goalsActionMap,
        rowData.goalType,
        rowData.goal,
        isGoalInUse,
    ]);
    var disableRow = React.useMemo(function () {
        if (readOnly)
            return true;
        if (disabled)
            return true;
        if (!isLatestVersion) {
            return true;
        }
        if ((currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Completed ||
            (currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Cancelled) {
            return true;
        }
        return false;
    }, [isLatestVersion, currentRow === null || currentRow === void 0 ? void 0 : currentRow.status, readOnly, disabled]);
    var disableAttach = React.useMemo(function () {
        if (disabled)
            return true;
        if (!rowData.goalType ||
            !rowData.goal ||
            !rowData.action) {
            return true;
        }
        if ((currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Completed ||
            (currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Cancelled) {
            return true;
        }
        return false;
    }, [
        rowData.goalType,
        rowData.goal,
        rowData.action,
        currentRow === null || currentRow === void 0 ? void 0 : currentRow.status,
        disabled
    ]);
    /**
     * @function disableGoalProgress
     * @description to disable goal percent button
     * @param status
     * @returns
     */
    // const disableGoalProgress = (status: GoalStatus) => {
    //   const disabledValues = [
    //     GoalStatus.Completed,
    //     GoalStatus.Cancelled,
    //     GoalStatus.Not_Started,
    //   ];
    //   if (!isLatestVersion || disabledValues.includes(status)) {
    //     return true;
    //   }
    //   return false;
    // };
    var disableGoalProgress = function (status) {
        if (disabled)
            return true;
        if (!isLatestVersion) {
            return true;
        }
        if ('isNewGoal' in rowData) {
            if (status === GoalStatus.Not_Started) {
                return true;
            }
        }
        else if (status === GoalStatus.Completed ||
            status === GoalStatus.Cancelled) {
            return true;
        }
        return false;
    };
    /**
     * @function disableGoalStatus
     * @description to disable status inputField untill goal and action was not added
     */
    var disableGoalStatus = React.useMemo(function () {
        if (rowData.goal && rowData.action) {
            return false;
        }
        return true;
    }, [rowData.goal, rowData.action]);
    /**
     * @function handleClickProgress
     * @description handle progress popup on click progress button
     * @param event
     */
    var handleClickProgress = function (event) {
        if (!disableGoalProgress(rowData.status)) {
            setAnchorEl(event.currentTarget);
        }
    };
    /**
     * @function handleClickAway
     * @description to close the progress bar overlay
     */
    var handleClickAway = function () {
        setAnchorEl(null);
    };
    var isCustomRow = React.useMemo(function () {
        if (rowData.isCustomGoal)
            return true;
        var goalTypeIsCustom = rowData.goalType && !goalsList.some(function (item) { return item.value === rowData.goalType; });
        var goalIsCustom = rowData.goal && !goalList.some(function (item) { return item.value === rowData.goal; });
        var actionIsCustom = rowData.action && !actionList.some(function (item) { return item.value === rowData.action; });
        return goalTypeIsCustom || goalIsCustom || actionIsCustom;
    }, [rowData.isCustomGoal, rowData.goalType, rowData.goal, rowData.action, goalsList, goalList, actionList]);
    /**
     * @function updateGoalContext
     * @description to update the value of any particular field
     * @param value
     * @param name
     */
    var updateGoalContext = useCallback(function (value, name) {
        dispatch(updateGoals(value, name, rowData, dispatchContext, isCustomRow));
    }, [dispatchContext, dispatch, rowData, isCustomRow]);
    /**
     * @description to set progress on the basis of status
     */
    React.useEffect(function () {
        if (rowData.status === GoalStatus.Completed) {
            updateGoalContext(100, 'progress');
        }
        else {
            updateGoalContext((currentRow === null || currentRow === void 0 ? void 0 : currentRow.progress) || 0, 'progress');
        }
        if (rowData.status === GoalStatus.Not_Started) {
            handleClickAway();
        }
    }, [rowData.status]);
    /**
     * @description to set status on the basis of progress
     */
    React.useEffect(function () {
        if (isLatestVersion) {
            if (rowData.progress === 100 && rowData.id) {
                if (!((currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Completed ||
                    (currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Cancelled)) {
                    updateGoalContext(moment().format(DATE_FORMAT), 'targetDate');
                }
                updateGoalContext(GoalStatus.Completed, 'status');
            }
            else {
                if (rowData.status !== GoalStatus.Completed) {
                    updateGoalContext(rowData.status, 'status');
                }
                else {
                    updateGoalContext(currentRow === null || currentRow === void 0 ? void 0 : currentRow.status, 'status');
                }
                updateGoalContext((currentRow === null || currentRow === void 0 ? void 0 : currentRow.targetDate) || '', 'targetDate');
            }
        }
    }, [rowData.progress, rowData.id]);
    var handleViewNotes = React.useCallback(function (id, version) {
        dispatch({ type: GET_GOALS_NOTES_LOADING });
        var openDialogProp = {
            successButtonText: 'Confirm',
            type: DIALOG_TYPES.GOAL_NOTES,
            isFailButton: true,
        };
        dispatch(openDialog(__assign({}, openDialogProp)));
        dispatch(getGoalsNotesData(id, version, customerID));
    }, [dispatch]);
    var rowDisable = React.useMemo(function () {
        if (readOnly)
            return true;
        if (disabled)
            return true;
        if (!isLatestVersion) {
            return true;
        }
        if ('isNewGoal' in rowData) {
            return false;
        }
        if ((currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Completed ||
            (currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Cancelled) {
            return true;
        }
        return false;
    }, [isLatestVersion, rowData, currentRow === null || currentRow === void 0 ? void 0 : currentRow.status, readOnly, disabled]);
    return (_jsxs(TableRow, { "data-testid": 'goalTabelRow', children: [_jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 250, minWidth: 250, verticalAlign: 'top' }, children: _jsx(InputFields, __assign({}, (isCustomRow
                    ? {
                        inputProps: {
                            name: 'goalType',
                            'data-testid': 'goalTypeInput',
                            placeholder: 'Enter Goal Type',
                        },
                        initialLabel: !rowData.isNewGoal ? rowData.goalType : '',
                        eventProps: {
                            value: rowData.goalType || '',
                            disabled: disableRow,
                            onChange: handleChange,
                            title: rowData.goalType,
                        },
                    }
                    : {
                        menu: true,
                        menuItems: goalsList,
                        inputProps: { name: 'goalType', 'data-testid': 'goalTypeInput' },
                        initialLabel: !rowData.isNewGoal ? rowData.goalType : 'Select a Goal Type',
                        eventProps: {
                            value: rowData.goalType || '',
                            disabled: (!rowData.isNewGoal && rowData.goalType) || disableRow,
                            onChange: handleChange,
                            title: rowData.goalType,
                        },
                    }), { isError: rowData.goalTypeError, errorText: rowData.goalTypeErrorText, isErrorCustomeStyle: true })) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 250, minWidth: 250, verticalAlign: 'top' }, children: _jsx(InputFields, __assign({}, (isCustomRow
                    ? {
                        inputProps: { name: 'goal', 'data-testid': 'goalInput', placeholder: 'Enter Goal' },
                        initialLabel: !rowData.isNewGoal ? rowData.goal : '',
                        eventProps: {
                            value: rowData.goal || '',
                            disabled: disableRow,
                            onChange: handleChange,
                            title: rowData.goal,
                        },
                    }
                    : {
                        menu: true,
                        menuItems: goalList,
                        inputProps: { name: 'goal', 'data-testid': 'goalInput' },
                        initialLabel: !rowData.isNewGoal ? rowData.goal : 'Select a Goal',
                        eventProps: {
                            value: rowData.goal || '',
                            disabled: (!rowData.isNewGoal && rowData.goal) ||
                                !rowData.goalType ||
                                disableRow,
                            onChange: handleChange,
                            title: rowData.goal,
                        },
                    }), { isError: rowData.goalError, errorText: rowData.goalErrorText, isErrorCustomeStyle: true })) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 250, minWidth: 250, verticalAlign: 'top' }, children: _jsx(Box, { display: 'flex', alignItems: 'center', children: _jsx(InputFields, __assign({}, (isCustomRow
                        ? {
                            inputProps: { name: 'action', 'data-testid': 'actionInput', placeholder: 'Enter Action' },
                            initialLabel: !rowData.isNewGoal ? rowData.action : '',
                            eventProps: {
                                value: rowData.action || '',
                                disabled: disableRow,
                                onChange: handleChange,
                                title: rowData.action,
                            },
                        }
                        : {
                            menu: true,
                            menuItems: actionList,
                            inputProps: { name: 'action', 'data-testid': 'actionInput' },
                            initialLabel: !rowData.isNewGoal ? rowData.action : 'Select an Action',
                            eventProps: {
                                value: rowData.action || '',
                                disabled: (!rowData.isNewGoal && rowData.action) ||
                                    !rowData.goal ||
                                    disableRow,
                                onChange: handleChange,
                                title: rowData.action,
                            },
                        }), { isError: rowData.actionError, errorText: rowData.actionErrorText, isErrorCustomeStyle: true })) }) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 180, minWidth: 180, verticalAlign: 'top' }, children: _jsx(Typography, { component: "div", variant: 'body2', style: { marginTop: '10px' }, children: rowData.status === GoalStatus.Not_Started ||
                        rowData.status === GoalStatus.In_Progress ||
                        rowData.status === GoalStatus.Started
                        ? 'Active'
                        : rowData.status === GoalStatus.Completed
                            ? 'Archived'
                            : rowData.status }) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 180, minWidth: 180, verticalAlign: 'top' }, children: _jsx(InputFields, { controlledDate: true, inputProps: {
                        name: 'startDate',
                    }, isError: errorTextStart ? true : false, errorText: errorTextStart, eventProps: {
                        value: rowData.startDate || null,
                        onChange: function (date, value) {
                            if (value) {
                                handleDateChange(moment(value, DATE_FORMAT, true), 'startDate');
                            }
                            else {
                                handleDateChange(moment(date).format(DATE_FORMAT), 'startDate');
                            }
                        },
                        onError: function (error) {
                            switch (error) {
                                case 'invalidDate':
                                    setErrorTextStart(INVALID_DATE);
                                    break;
                                case 'maxDate':
                                    setErrorTextStart(DATE_ERROR_MESSAGE.goals.startDate);
                                    break;
                                default:
                                    setErrorTextStart('');
                            }
                        },
                        minDate: moment(seniorCreatedDate).format(DATE_FORMAT),
                        disabled: rowDisable,
                        maxDate: moment().format(DATE_FORMAT), // Disable future dates
                        // maxDate: rowData.targetDate ? rowData.targetDate : undefined,
                    }, isErrorCustomeStyle: true }) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 180, minWidth: 180, verticalAlign: 'top' }, children: _jsx(InputFields, { controlledDate: true, inputProps: { name: 'targetDate' }, isError: errorTextTarget ? true : false, errorText: errorTextTarget, eventProps: {
                        value: rowData.targetDate || null,
                        onChange: function (date, value) {
                            if (value) {
                                handleDateChange(moment(value, DATE_FORMAT, true), 'targetDate');
                            }
                            else {
                                handleDateChange(moment(date).format(DATE_FORMAT), 'targetDate');
                            }
                        },
                        onError: function (error) {
                            switch (error) {
                                case 'invalidDate':
                                    setErrorTextTarget(INVALID_DATE);
                                    break;
                                case 'minDate':
                                    setErrorTextTarget(DATE_ERROR_MESSAGE.goals.targetDate);
                                    break;
                                default:
                                    setErrorTextTarget('');
                            }
                        },
                        disabled: rowDisable,
                        minDate: rowData.startDate ? rowData.startDate : undefined,
                    }, isErrorCustomeStyle: true }) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 230, minWidth: 130, verticalAlign: 'top' }, children: _jsx(Checkbox, { checked: !!((rowData === null || rowData === void 0 ? void 0 : rowData.status) === GoalStatus.Completed), disabled: readOnly || disabled || !rowData.id || (currentRow === null || currentRow === void 0 ? void 0 : currentRow.status) === GoalStatus.Completed, onChange: function (event) {
                        if (disabled)
                            return;
                        var isChecked = event.target.checked;
                        setLocalChecked(isChecked); // instant UI update
                        var newStatus = isChecked
                            ? GoalStatus.Completed
                            : GoalStatus.In_Progress;
                        dispatch(updateGoals(newStatus, 'status', rowData, dispatchContext, isCustomRow));
                    }, inputProps: { 'aria-label': 'Goal status checkbox' } }) }), _jsx(TableCell, { className: classes.tableBodyCell, align: 'left', style: { maxWidth: 380, minWidth: 380, verticalAlign: 'top' }, children: _jsx(Box, { children: _jsx(InputFields, { inputProps: {
                            placeholder: 'Please enter notes here',
                            name: 'notes',
                            required: true,
                            maxLength: 2000,
                            style: { padding: 0 },
                        }, eventProps: {
                            onChange: handleChange,
                            value: rowData.notes || '',
                            disabled: rowDisable,
                        }, multiline: true, rows: 5, isLabel: false, label: '' }) }) }), _jsx(TableCell, { className: classes.tableBtn, align: 'center', children: _jsx(Button, { onClick: function () { return handleViewNotes(currentRow.id, currentRow.current_version); }, size: 'small', color: 'primary', variant: 'contained', style: { width: '48px' }, disabled: currentRow === undefined, children: "View Notes" }) }), _jsx(TableCell, { className: classes.tableBtn, align: 'center', children: _jsx(AttachIconWithCount, { onClick: function () { return resourceshandler(rowData, rowDisable); }, disableAttach: disableAttach, filesCount: Array.isArray(rowData === null || rowData === void 0 ? void 0 : rowData.resource) ? rowData.resource.length : 0 }) }), _jsx(TableCell, { className: classes.tableBtn, align: 'left', children: _jsx(HighlightOffIcon, { "data-testid": 'deleteIcon', onClick: deleteGoalhandler, className: clsx((_b = {},
                        _b[classes.removeIcon] = true,
                        _b[classes.removeIconDisable] = disabled || disableRow || isDeleteDisable,
                        _b)) }) })] }));
});
export default GoalsTableRow;
